import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { useDispatch } from 'react-redux';
import { getAssignedJobPoolInformations, getJobTailTypes } from 'src/store/slices/generalMonitoringSlice';
import {
  BAR,
  ChartSkeleton,
  DonutChart,
  LegendRow,
  MonitorCard,
  MultiSelectFilter,
  SECOND,
  formatNumber,
  formatPercent
} from 'src/components/monitoring/MonitoringParts';

// Kuyruk tipine göre havuzdaki fişlerin atanma durumu
function AssignedJobPoolChart() {
  const dispatch = useDispatch();
  const [mainData, setMainData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [jobPoolTypes, setJobPoolTypes] = useState([]);
  const [selectedJobPoolTypes, setSelectedJobPoolTypes] = useState([]);

  const GetAssignedJobPoolInformations = (jobTailType) => {
    setLoading(true);
    dispatch(getAssignedJobPoolInformations(jobTailType))
      .then((response) => {
        setMainData(Array.isArray(response?.payload) ? response.payload : []);
        setLoading(false);
      })
      .catch(() => {
        setMainData([]);
        setLoading(false);
      });
  };

  useEffect(() => {
    dispatch(getJobTailTypes())
      .then((response) => setJobPoolTypes(Array.isArray(response?.payload) ? response.payload : []))
      .catch(() => {});
    GetAssignedJobPoolInformations('0');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Seçim boşsa tümü ('0')
  const handleSearchData = () => {
    const ids = (selectedJobPoolTypes || []).map((row) => row.Id);
    GetAssignedJobPoolInformations(ids.length ? ids.toString() : '0');
  };

  const row = mainData?.[0] || {};
  const total = Number(row.TOPLAMFISADET) || 0;
  const unassigned = Number(row.ATAMASIYAPILMAYANADET) || 0;
  const assigned = Number(row.ATAMASIYAPILANADET) || 0;

  return (
    <MonitorCard
      title="İş Havuzu"
      subtitle="Havuzdaki fişlerin atanma durumu"
      action={
        <MultiSelectFilter
          label="Kuyruk tipi (tümü)"
          options={jobPoolTypes}
          value={selectedJobPoolTypes}
          onChange={setSelectedJobPoolTypes}
          onApply={handleSearchData}
          disabled={loading}
        />
      }
    >
      {loading ? (
        <ChartSkeleton height={180} />
      ) : (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, flexWrap: 'wrap', justifyContent: 'center' }}>
          <DonutChart
            centerValue={formatNumber(total)}
            centerLabel="toplam fiş"
            segments={[
              { label: 'Ataması yapılan', value: assigned, color: BAR },
              { label: 'Ataması yapılmayan', value: unassigned, color: SECOND }
            ]}
          />
          <Box sx={{ flex: 1, minWidth: 200 }}>
            <LegendRow color="#b0bec5" label="Toplam fiş" value={formatNumber(total)} />
            <LegendRow color={BAR} label="Ataması yapılan" value={formatNumber(assigned)} share={formatPercent(assigned, total)} />
            <LegendRow color={SECOND} label="Ataması yapılmayan" value={formatNumber(unassigned)} share={formatPercent(unassigned, total)} />
          </Box>
        </Box>
      )}
    </MonitorCard>
  );
}

export default AssignedJobPoolChart;
